// import { useEffect, useState } from "react";
// import { useSearchParams, useNavigate } from "react-router-dom";
// import { db } from "../firebase/firebase";
// import { doc, getDoc, updateDoc, runTransaction, addDoc, collection } from "firebase/firestore";

// export default function StudentDetails() {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const id = searchParams.get("id");

//   const [student, setStudent] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);

//   const [showFeesModal, setShowFeesModal] = useState(false);
//   const [feeData, setFeeData] = useState({
//     amount: "",
//     receiveDate: "",
//     paymentMode: "",
//     reference: "",
//   });

//   const isAdmitted = student?.status === "admitted";
//   const [activeTab, setActiveTab] = useState("details");

//   // 🔥 Fetch student
//   useEffect(() => {
//     if (!id) return;

//     const fetchStudent = async () => {
//       try {
//         const snap = await getDoc(doc(db, "students", id));

//         if (snap.exists()) {
//           setStudent({ id: snap.id, ...snap.data() });
//         } else {
//           alert("Student not found");
//           navigate("/dashboard/students");
//         }
//       } catch (err) {
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchStudent();
//   }, [id, navigate]);

//   // 🔄 Handle change
//   const handleChange = (e) => {
//     setStudent({
//       ...student,
//       [e.target.name]: e.target.value,
//     });
//   };

//   // 💾 Update student
//   const handleUpdate = async (e) => {
//     e.preventDefault();
//     setSaving(true);

//     try {
//       await updateDoc(doc(db, "students", id), student);
//       alert("Updated successfully ✅");
//     } catch (err) {
//       console.error(err);
//       alert("Update failed ❌");
//     } finally {
//       setSaving(false);
//     }
//   };

//   // 💰 Calculations
//   const totalPaid = (student?.feesReceived || []).reduce(
//     (sum, fee) => sum + Number(fee.amount),
//     0
//   );

//   const remaining =
//     Number(student?.totalFees || 0) - Number(totalPaid || 0);

//   const sortedFees = [...(student?.feesReceived || [])].sort(
//     (a, b) => new Date(b.receiveDate) - new Date(a.receiveDate)
//   );

//   if (!id) return <div className="text-white">Invalid ID</div>;
//   if (loading) return <div className="text-white">Loading...</div>;
//   if (!student) return null;




// const handleCreateInvoice = async (fee, index) => {
//   try {
//     let newInvoiceNo = "";

//     await runTransaction(db, async (transaction) => {
//       const counterRef = doc(db, "counters", "invoice");
//       const counterSnap = await transaction.get(counterRef);

//       let newNumber = 1;

//       if (counterSnap.exists()) {
//         newNumber = counterSnap.data().lastNumber + 1;
//       }

//       // 🔥 Update counter
//       transaction.set(counterRef, { lastNumber: newNumber });

//       // 🔥 Format invoice number
//       const padded = String(newNumber).padStart(4, "0");
//       newInvoiceNo = `INV-${new Date().getFullYear()}-${padded}`;
//     });

//     // 💰 GST LOGIC
//     const amount = Number(fee.amount);

//     let gstAmount = 0;
//     let baseAmount = amount;

//     // if (fee.billType === "gst") {
//     gstAmount = (amount * 18) / 118;
//     baseAmount = amount - gstAmount;
//     // }
//     const billType = "gst"; // ✅ fallback

//     const invoiceData = {
//       studentId: student.id,
//       studentName: student.fullName,

//       invoiceNo: newInvoiceNo,

//       amount,
//       baseAmount,
//       gstAmount,

//       billType: billType,

//       paymentMode: fee.paymentMode,
//       reference: fee.reference,

//       course: student.course,

//       date: fee.receiveDate,

//       createdAt: new Date(),
//     };

//     // 🔥 Save invoice
//     await addDoc(collection(db, "invoices"), invoiceData);

//     // 🔥 Mark as invoiced
//     await updateDoc(doc(db, "students", student.id), {
//       feesReceived: student.feesReceived.map((f, i) =>
//         i === index ? { ...f, invoiceCreated: true } : f
//       ),
//     });

//     alert(`Invoice Created: ${newInvoiceNo} ✅`);

//   } catch (err) {
//     console.error(err);
//     alert("Failed ❌");
//   }
// };


//   return (
//     <div className="text-white">

//       {/* 🔙 Back */}
//       <button
//         onClick={() => navigate("/dashboard/students")}
//         className="mb-4 text-orange-400 hover:underline"
//       >
//         ← Back to Students
//       </button>

//       {/* 🔥 HEADER */}
//       <div className="flex justify-between items-center mb-6">
//         <div>
//           <h1 className="text-2xl font-bold text-orange-500">
//             {student.fullName}
//           </h1>
//           <p className="text-sm text-slate-400">{student.mobile}</p>
//         </div>

//         <span className="px-3 py-1 rounded bg-blue-500/20 text-blue-400 text-sm">
//           {student.status}
//         </span>
//       </div>



//       <div className="flex gap-2 mb-6 bg-white/5 p-2 rounded-xl w-full">

//         <button
//           onClick={() => setActiveTab("details")}
//           className={`px-4 py-2 w-full rounded-lg text-sm font-medium transition-all ${activeTab === "details"
//             ? "bg-orange-500 text-white"
//             : "text-slate-300 hover:bg-white/10"
//             }`}
//         >
//           Details
//         </button>

//         <button
//           onClick={() => setActiveTab("fees")}
//           className={`px-4 py-2 w-full rounded-lg text-sm font-medium transition-all ${activeTab === "fees"
//             ? "bg-orange-500 text-white"
//             : "text-slate-300 hover:bg-white/10"
//             }`}
//         >
//           Fees
//         </button>

//         <button
//           onClick={() => setActiveTab("invoice")}
//           className={`px-4 py-2 w-full rounded-lg text-sm font-medium transition-all ${activeTab === "invoice"
//             ? "bg-orange-500 text-white"
//             : "text-slate-300 hover:bg-white/10"
//             }`}
//         >
//           Invoice
//         </button>

//       </div>


//       <div className={`bg-white/5 p-10 rounded-xl w-full ${activeTab === "details" ? "block" : "hidden"}`}>

//         {/* 🧾 FORM */}
//         <form
//           onSubmit={handleUpdate}
//           className="max-w-full space-y-5 bg-white/10 p-6 rounded-xl border border-white/10"
//         >
//           <input
//             name="fullName"
//             value={student.fullName || ""}
//             onChange={handleChange}
//             className="w-full p-3 rounded bg-black/40 border border-white/20"
//             placeholder="Full Name"
//           />

//           <input
//             name="mobile"
//             value={student.mobile || ""}
//             onChange={handleChange}
//             className="w-full p-3 rounded bg-black/40 border border-white/20"
//             placeholder="Mobile"
//           />

//           <select
//             name="status"
//             value={student.status || "new"}
//             onChange={handleChange}
//             className="w-full p-3 rounded bg-black/40 border border-white/20"
//           >
//             <option value="new">New</option>
//             <option value="approved">Approved</option>
//             <option value="rejected">Rejected</option>
//             <option value="admitted">Admitted</option>
//           </select>

//           <textarea
//             name="notes"
//             value={student.notes || ""}
//             onChange={handleChange}
//             className="w-full p-3 rounded bg-black/40 border border-white/20"
//             placeholder="Admin Notes"
//           />

//           <button
//             type="submit"
//             disabled={saving}
//             className="bg-orange-500 px-6 py-2 rounded"
//           >
//             {saving ? "Saving..." : "Update Student"}
//           </button>
//         </form>

//       </div>

//       <div className={`bg-white/5 p-10 rounded-xl w-full ${activeTab === "fees" ? "block" : "hidden"}`}>


//         {/* 🧱 ADMISSION + SUMMARY */}
//         <div className="grid md:grid-cols-2 gap-6 mt-10">

//           {/* Admission */}
//           <div className="bg-white/10 p-6 rounded-xl border border-white/10 space-y-4">
//             <h2 className="text-xl font-semibold">Admission Details</h2>

//             <input
//               type="number"
//               placeholder="Total Fees"
//               value={student.totalFees || ""}
//               disabled={!isAdmitted}
//               onChange={(e) =>
//                 setStudent({ ...student, totalFees: e.target.value })
//               }
//               className="w-full p-3 rounded bg-black/40 border border-white/20"
//             />

//             <input
//               type="date"
//               value={student.admissionDate || ""}
//               disabled={!isAdmitted}
//               onChange={(e) =>
//                 setStudent({ ...student, admissionDate: e.target.value })
//               }
//               className="w-full p-3 rounded bg-black/40 border border-white/20"
//             />

//             <input
//               type="date"
//               value={student.classStartDate || ""}
//               disabled={!isAdmitted}
//               onChange={(e) =>
//                 setStudent({ ...student, classStartDate: e.target.value })
//               }
//               className="w-full p-3 rounded bg-black/40 border border-white/20"
//             />

//             {isAdmitted && (
//               <button
//                 onClick={async () => {
//                   await updateDoc(doc(db, "students", id), {
//                     status: "admitted",
//                     totalFees: student.totalFees,
//                     admissionDate: student.admissionDate,
//                     classStartDate: student.classStartDate,
//                   });

//                   setStudent((prev) => ({
//                     ...prev,
//                     status: "admitted",
//                   }));

//                   alert("Student Admitted ✅");
//                 }}
//                 className="bg-green-600 px-4 py-2 rounded"
//               >
//                 Admit Student
//               </button>
//             )}
//           </div>

//           {/* Fee Summary */}
//           <div className="bg-white/10 p-6 rounded-xl border border-white/10 space-y-2">
//             <h2 className="text-lg font-semibold">Fee Summary</h2>

//             <p>Total Fees: ₹{student.totalFees || 0}</p>
//             <p>Total Paid: ₹{totalPaid}</p>

//             <p className="text-red-400 font-semibold">
//               Remaining: ₹{remaining}
//             </p>

//             {isAdmitted && (
//               <button
//                 onClick={() => setShowFeesModal(true)}
//                 className="mt-4 bg-orange-500 px-4 py-2 rounded"
//               >
//                 Add Fees
//               </button>
//             )}
//           </div>
//         </div>

//         {/* 💰 FEES MODAL */}
//         {showFeesModal && (
//           <div className="fixed inset-0 bg-black/70 flex items-center justify-center">
//             <div className="bg-[#1f1f1f] p-6 rounded w-full max-w-md space-y-4">

//               <h2 className="text-lg font-semibold">Fees Received</h2>

//               <input
//                 type="number"
//                 placeholder="Amount"
//                 className="w-full p-2 bg-black/40 border border-white/20 rounded"
//                 onChange={(e) =>
//                   setFeeData({ ...feeData, amount: e.target.value })
//                 }
//               />

//               <input
//                 type="date"
//                 className="w-full p-2 bg-black/40 border border-white/20 rounded"
//                 onChange={(e) =>
//                   setFeeData({ ...feeData, receiveDate: e.target.value })
//                 }
//               />

//               <input
//                 type="text"
//                 placeholder="Payment Mode"
//                 className="w-full p-2 bg-black/40 border border-white/20 rounded"
//                 onChange={(e) =>
//                   setFeeData({ ...feeData, paymentMode: e.target.value })
//                 }
//               />

//               <input
//                 type="text"
//                 placeholder="Reference"
//                 className="w-full p-2 bg-black/40 border border-white/20 rounded"
//                 onChange={(e) =>
//                   setFeeData({ ...feeData, reference: e.target.value })
//                 }
//               />

//               <div className="flex justify-between">
//                 <button
//                   onClick={() => setShowFeesModal(false)}
//                   className="bg-gray-500 px-4 py-2 rounded"
//                 >
//                   Cancel
//                 </button>

//                 <button
//                   onClick={async () => {
//                     if (!feeData.amount || !feeData.receiveDate) {
//                       alert("Fill required fields");
//                       return;
//                     }

//                     const newFee = {
//                       ...feeData,
//                       createdAt: new Date(),
//                     };

//                     await updateDoc(doc(db, "students", id), {
//                       feesReceived: [
//                         ...(student.feesReceived || []),
//                         newFee,
//                       ],
//                     });

//                     setStudent((prev) => ({
//                       ...prev,
//                       feesReceived: [
//                         ...(prev.feesReceived || []),
//                         newFee,
//                       ],
//                     }));

//                     setShowFeesModal(false);
//                     setFeeData({
//                       amount: "",
//                       receiveDate: "",
//                       paymentMode: "",
//                       reference: "",
//                     });
//                   }}
//                   className="bg-green-600 px-4 py-2 rounded"
//                 >
//                   Submit
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//       </div>

//       <div className={`bg-white/5 p-10 rounded-xl w-full ${activeTab === "invoice" ? "block" : "hidden"}`}>


//         {/* 📊 FEES HISTORY */}
//         {isAdmitted && (
//           <div className="mt-10 bg-white/10 p-6 rounded-xl border border-white/10">

//             <h2 className="text-xl font-semibold mb-4">Fees History</h2>

//             <table className="min-w-full text-sm text-gray-300">
//               <thead className="bg-white/10">
//                 <tr>
//                   <th className="px-4 py-2">Date</th>
//                   <th className="px-4 py-2">Amount</th>
//                   <th className="px-4 py-2">Mode</th>
//                   <th className="px-4 py-2">Reference</th>
//                   <th className="px-4 py-2"></th>
//                   <th className="px-4 py-2"></th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {sortedFees.map((fee, index) => (
//                   <tr key={index} className="text-center border-b border-white/10">
//                     <td className="px-4 py-2">{fee.receiveDate}</td>
//                     <td className="px-4 py-2">₹{fee.amount}</td>
//                     <td className="px-4 py-2">{fee.paymentMode}</td>
//                     <td className="px-4 py-2">{fee.reference}</td>
//                     <td>
//                       <button className="btn text-[lightblue]" onClick={() =>
//                         navigate(`/dashboard/invoice?id=${student.id}&fee=${index}`)
//                       }>
//                         Invoice
//                       </button>
//                     </td>
//                     <td>
//                       <button
//                         onClick={() => handleCreateInvoice(fee, index)}
//                         className="text-green-400 hover:underline"
//                       >
//                         Create GST Invoice
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>



//     </div>
//   );
// }



import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { db } from "../firebase/firebase";
import { doc, getDoc, updateDoc, runTransaction, addDoc, collection } from "firebase/firestore";
import { writeBatch } from "firebase/firestore";

export default function StudentDetails() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const id = searchParams.get("id");

  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [allCourses, setAllCourses] = useState([]);

  const [showFeesModal, setShowFeesModal] = useState(false);
  const [feeData, setFeeData] = useState({
    amount: "",
    receiveDate: "",
    paymentMode: "",
    reference: "",
  });

  const isAdmitted = student?.status === "admitted";
  const [activeTab, setActiveTab] = useState("details");


  /* ---------------- FETCH ---------------- */
  useEffect(() => {

    if (!id) return;

    const fetchStudent = async () => {

      try {

        const snap = await getDoc(doc(db, "students", id));

        if (snap.exists()) {
          setStudent({ id: snap.id, ...snap.data() });
        } else {
          alert("Student not found");
          navigate("/dashboard/students");
        }

      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    /* FETCH COURSES */
    const fetchCourses = async () => {

      try {

        const courseSnap = await getDoc(
          doc(db, "course", "allCourses")
        );

        if (courseSnap.exists()) {
          setAllCourses(courseSnap.data().courses || []);
        }

      } catch (err) {
        console.error(err);
      }
    };

    fetchStudent();
    fetchCourses();

  }, [id, navigate]);

  /* ---------------- CHANGE ---------------- */
  const handleChange = (e) => {
    setStudent({
      ...student,
      [e.target.name]: e.target.value,
    });
  };



  /* ---------------- COURSE CHECKBOX ---------------- */
  const handleCourseChange = (courseTitle) => {

    const currentCourses = student.course || [];

    let updatedCourses = [];

    if (currentCourses.includes(courseTitle)) {

      updatedCourses = currentCourses.filter(
        (c) => c !== courseTitle
      );

    } else {

      updatedCourses = [
        ...currentCourses,
        courseTitle,
      ];
    }

    setStudent({
      ...student,
      course: updatedCourses,
    });
  };


  /* ---------------- UPDATE ---------------- */
  const handleUpdate = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      await updateDoc(doc(db, "students", id), student);
      alert("Updated successfully ✅");
    } catch (err) {
      console.error(err);
      alert("Update failed ❌");
    } finally {
      setSaving(false);
    }
  };

  /* ---------------- CALCULATIONS ---------------- */
  const totalPaid = (student?.feesReceived || []).reduce(
    (sum, fee) => sum + Number(fee.amount),
    0
  );

  const remaining =
    Number(student?.totalFees || 0) - Number(totalPaid || 0);

  const sortedFees = [...(student?.feesReceived || [])].sort(
    (a, b) => new Date(b.receiveDate) - new Date(a.receiveDate)
  );

  if (!id) return <div className="text-white">Invalid ID</div>;
  if (loading) return <div className="text-white">Loading...</div>;
  if (!student) return null;


  const handleCreateInvoice = async (fee, index) => {
    try {
      let newInvoiceNo = "";
      let newNumber = 1;

      /* ---------------- TRANSACTION (COUNTER) ---------------- */
      await runTransaction(db, async (transaction) => {
        const counterRef = doc(db, "counters", "invoice");
        const counterSnap = await transaction.get(counterRef);

        if (counterSnap.exists()) {
          newNumber = counterSnap.data().lastNumber + 1;
        }

        transaction.set(counterRef, { lastNumber: newNumber });

        const padded = String(newNumber).padStart(4, "0");
        newInvoiceNo = `INV-${new Date().getFullYear()}-${padded}`;
      });

      /* ---------------- GST LOGIC ---------------- */
      const amount = Number(fee.amount);

      const gstAmount = (amount * 18) / 118;
      const baseAmount = amount - gstAmount;

      const invoiceData = {
        studentId: student.id,
        studentName: student.fullName,
        invoiceNo: newInvoiceNo,
        amount,
        baseAmount,
        gstAmount,
        billType: "gst",
        paymentMode: fee.paymentMode,
        reference: fee.reference,
        course: student.course,
        date: fee.receiveDate,
        createdAt: new Date(),
      };

      /* ---------------- BATCH START ---------------- */
      const batch = writeBatch(db);

      // 🔹 Invoice Ref (IMPORTANT: manual doc ref, not addDoc)
      const invoiceRef = doc(collection(db, "invoices"));

      batch.set(invoiceRef, invoiceData);

      // 🔹 Update student fees array
      const updatedFees = student.feesReceived.map((f, i) =>
        i === index ? { ...f, invoiceCreated: true } : f
      );

      const studentRef = doc(db, "students", student.id);

      batch.update(studentRef, {
        feesReceived: updatedFees,
      });

      /* ---------------- COMMIT ---------------- */
      await batch.commit();

      // 🔹 Local state update (UI sync)
      setStudent((prev) => ({
        ...prev,
        feesReceived: updatedFees,
      }));

      alert(`Invoice Created: ${newInvoiceNo} ✅`);

    } catch (err) {
      console.error(err);
      alert("Failed ❌");
    }
  };


  return (
    <div className="text-white">

      {/* BACK */}
      <button
        onClick={() => navigate("/dashboard/students")}
        className="mb-4 text-orange-400 hover:underline"
      >
        ← Back to Students
      </button>

      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-orange-500">
            {student.fullName}
          </h1>
          <p className="text-sm text-slate-400">{student.mobile}</p>
        </div>

        <span className="px-3 py-1 rounded bg-blue-500/20 text-blue-400 text-sm">
          {student.status}
        </span>
      </div>

      {/* TABS */}
      <div className="flex gap-2 mb-6 bg-white/5 p-2 rounded-xl w-full">
        {["details", "fees", "invoice"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 w-full rounded-lg text-sm font-medium ${activeTab === tab
              ? "bg-orange-500 text-white"
              : "text-slate-300 hover:bg-white/10"
              }`}
          >
            {tab.toUpperCase()}
          </button>
        ))}
      </div>

      {/* ================= DETAILS ================= */}
      <div className={`bg-white/5 p-10 rounded-xl ${activeTab === "details" ? "block" : "hidden"}`}>

        <form onSubmit={handleUpdate} className="space-y-6 bg-white/10 p-6 rounded-xl border border-white/10">

          <Section title="Basic Information">
            <div className="grid md:grid-cols-3 gap-4">
              <Input name="fullName" value={student.fullName || ""} onChange={handleChange} placeholder="Full Name" />
              <Input name="mobile" value={student.mobile || ""} onChange={handleChange} placeholder="Mobile" />
              <Input name="email" value={student.email || ""} onChange={handleChange} placeholder="Email" />
              <Select name="gender" value={student.gender || ""} onChange={handleChange} options={["Male", "Female", "Other"]} />
              <Select name="status" value={student.status || ""} onChange={handleChange} options={["new", "approved", "admitted", "rejected"]} />
              <Input type="date" name="dob" value={student.dob || ""} onChange={handleChange} />
            </div>
          </Section>

          <Section title="Address">
            <div className="grid md:grid-cols-2 gap-4">
              <Input name="address" value={student.address || ""} onChange={handleChange} placeholder="Address" />
              <Input name="city" value={student.city || ""} onChange={handleChange} placeholder="City" />
              <Input name="state" value={student.state || ""} onChange={handleChange} placeholder="State" />
              <Input name="pincode" value={student.pincode || ""} onChange={handleChange} placeholder="Pincode" />
            </div>
          </Section>

          <Section title="Education">
            <div className="grid md:grid-cols-3 gap-4">
              <Select name="educationType" value={student.educationType || ""} onChange={handleChange} options={["School", "College"]} />

              {student.educationType === "College" && (
                <Input name="collegeName" value={student.collegeName || ""} onChange={handleChange} placeholder="College Name" />
              )}

              {student.educationType === "School" && (
                <Input name="schoolName" value={student.schoolName || ""} onChange={handleChange} placeholder="School Name" />
              )}

              <Input name="degree" value={student.degree || ""} onChange={handleChange} placeholder="Degree" />
              <Input name="year" value={student.year || ""} onChange={handleChange} placeholder="Year" />
            </div>
          </Section>

          <Section title="Course & Admission">
            <div className="grid md:grid-cols-3 gap-4">
              {/* <Input name="course" value={student.course || ""} onChange={handleChange} placeholder="Course" /> */}

              <div className="md:col-span-3">

                <label className="block mb-3 text-sm text-slate-300">
                  Courses
                </label>

                <div className="grid md:grid-cols-3 gap-3">

                  {allCourses.map((course, index) => {

                    const checked = (student.course || []).includes(course.title);

                    return (

                      <label
                        key={index}
                        className={`
            flex items-center gap-3 p-3 rounded-xl border cursor-pointer transition-all
            ${checked
                            ? "bg-orange-500/20 border-orange-500"
                            : "bg-black/30 border-white/10 hover:border-orange-500/50"
                          }
          `}
                      >

                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={() => handleCourseChange(course.title)}
                          className="w-4 h-4 accent-orange-500"
                        />

                        <span className="text-sm">
                          {course.title}
                        </span>

                      </label>
                    );
                  })}

                </div>

              </div>


              <Input type="date" name="admissionDate" value={student.admissionDate || ""} onChange={handleChange} />
              <Input type="date" name="classStartDate" value={student.classStartDate || ""} onChange={handleChange} />
              <Input name="source" value={student.source || ""} onChange={handleChange} placeholder="Source" />
            </div>
          </Section>

          <Section title="Admin Notes">
            <textarea
              name="notes"
              value={student.notes || ""}
              onChange={handleChange}
              className="w-full p-3 rounded bg-black/40 border border-white/20"
              rows={4}
            />
          </Section>

          <div className="sticky bottom-0 bg-black/60 p-4 rounded-xl flex justify-end">
            <button
              type="submit"
              disabled={saving}
              className="bg-orange-500 px-6 py-3 rounded-lg"
            >
              {saving ? "Saving..." : "Update Student"}
            </button>
          </div>

        </form>
      </div>

      {/* ================= FEES ================= */}
      <div className={`bg-white/5 p-10 rounded-xl grid grid-cols-2 gap-5 ${activeTab === "fees" ? "block" : "hidden"}`}>



        {/* Admission */}
        <div className="bg-white/10 p-6 rounded-xl border border-white/10 space-y-4">
          <h2 className="text-xl font-semibold">Admission Details</h2>

          <input
            type="number"
            placeholder="Total Fees"
            value={student.totalFees || ""}
            disabled={!isAdmitted}
            onChange={(e) =>
              setStudent({ ...student, totalFees: e.target.value })
            }
            className="w-full p-3 rounded bg-black/40 border border-white/20"
          />

          <input
            type="date"
            value={student.admissionDate || ""}
            disabled={!isAdmitted}
            onChange={(e) =>
              setStudent({ ...student, admissionDate: e.target.value })
            }
            className="w-full p-3 rounded bg-black/40 border border-white/20"
          />

          <input
            type="date"
            value={student.classStartDate || ""}
            disabled={!isAdmitted}
            onChange={(e) =>
              setStudent({ ...student, classStartDate: e.target.value })
            }
            className="w-full p-3 rounded bg-black/40 border border-white/20"
          />

          {isAdmitted && (
            <button
              onClick={async () => {
                await updateDoc(doc(db, "students", id), {
                  status: "admitted",
                  totalFees: student.totalFees,
                  admissionDate: student.admissionDate,
                  classStartDate: student.classStartDate,
                });

                setStudent((prev) => ({
                  ...prev,
                  status: "admitted",
                }));

                alert("Student Admitted ✅");
              }}
              className="bg-green-600 px-4 py-2 rounded"
            >
              Admit Student
            </button>
          )}
        </div>

        {/* Fee Summary */}
        <div className="bg-white/10 p-6 rounded-xl border border-white/10 space-y-2">
          <h2 className="text-lg font-semibold">Fee Summary</h2>

          <p>Total Fees: ₹{student.totalFees || 0}</p>
          <p>Total Paid: ₹{totalPaid}</p>

          <p className="text-red-400 font-semibold">
            Remaining: ₹{remaining}
          </p>

          {isAdmitted && (

            remaining > 0 ? (

              <button
                onClick={() => setShowFeesModal(true)}
                className="mt-4 bg-orange-500 hover:bg-orange-600 transition-all px-4 py-2 rounded"
              >
                Add Fees
              </button>

            ) : (

              <button
                disabled
                className="mt-4 bg-green-600/30 text-green-400 px-4 py-2 rounded cursor-not-allowed"
              >
                Fees Completed
              </button>

            )

          )}

          {/* {isAdmitted && (
            <button
              onClick={() => setShowFeesModal(true)}
              className="mt-4 bg-orange-500 px-4 py-2 rounded"
            >
              Add Fees
            </button>
          )} */}
        </div>

        {/* 💰 FEES MODAL */}
        {showFeesModal && (
          <div className="fixed inset-0 bg-black/70 flex items-center justify-center">
            <div className="bg-[#1f1f1f] p-6 rounded w-full max-w-md space-y-4">

              <h2 className="text-lg font-semibold">Fees Received</h2>

              <input
                type="number"
                placeholder="Amount"
                className="w-full p-2 bg-black/40 border border-white/20 rounded"
                onChange={(e) =>
                  setFeeData({ ...feeData, amount: e.target.value })
                }
              />

              <input
                type="date"
                className="w-full p-2 bg-black/40 border border-white/20 rounded"
                onChange={(e) =>
                  setFeeData({ ...feeData, receiveDate: e.target.value })
                }
              />

              <input
                type="text"
                placeholder="Payment Mode"
                className="w-full p-2 bg-black/40 border border-white/20 rounded"
                onChange={(e) =>
                  setFeeData({ ...feeData, paymentMode: e.target.value })
                }
              />

              <input
                type="text"
                placeholder="Reference"
                className="w-full p-2 bg-black/40 border border-white/20 rounded"
                onChange={(e) =>
                  setFeeData({ ...feeData, reference: e.target.value })
                }
              />

              <div className="flex justify-between">
                <button
                  onClick={() => setShowFeesModal(false)}
                  className="bg-gray-500 px-4 py-2 rounded"
                >
                  Cancel
                </button>

                <button
                  onClick={async () => {
                    if (!feeData.amount || !feeData.receiveDate) {
                      alert("Fill required fields");
                      return;
                    }

                    const newFee = {
                      ...feeData,
                      createdAt: new Date(),
                    };

                    await updateDoc(doc(db, "students", id), {
                      feesReceived: [
                        ...(student.feesReceived || []),
                        newFee,
                      ],
                    });

                    setStudent((prev) => ({
                      ...prev,
                      feesReceived: [
                        ...(prev.feesReceived || []),
                        newFee,
                      ],
                    }));

                    setShowFeesModal(false);
                    setFeeData({
                      amount: "",
                      receiveDate: "",
                      paymentMode: "",
                      reference: "",
                    });
                  }}
                  className="bg-green-600 px-4 py-2 rounded"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}



      </div>

      {/* ================= INVOICE ================= */}
      <div className={`bg-white/5 p-10 rounded-xl ${activeTab === "invoice" ? "block" : "hidden"}`}>


        {/* 📊 FEES HISTORY */}
        {isAdmitted && (
          <div className="mt-10 bg-white/10 p-6 rounded-xl border border-white/10">

            <h2 className="text-xl font-semibold mb-4">Fees History</h2>

            <table className="min-w-full text-sm text-gray-300">
              <thead className="bg-white/10">
                <tr>
                  <th className="px-4 py-2">Date</th>
                  <th className="px-4 py-2">Amount</th>
                  <th className="px-4 py-2">Mode</th>
                  <th className="px-4 py-2">Reference</th>
                  <th className="px-4 py-2"></th>
                  <th className="px-4 py-2"></th>
                </tr>
              </thead>

              <tbody>
                {sortedFees.map((fee, index) => (
                  <tr key={index} className="text-center border-b border-white/10">
                    <td className="px-4 py-2">{fee.receiveDate}</td>
                    <td className="px-4 py-2">₹{fee.amount}</td>
                    <td className="px-4 py-2">{fee.paymentMode}</td>
                    <td className="px-4 py-2">{fee.reference}</td>
                    <td>
                      <button className="btn text-[lightblue]" onClick={() =>
                        navigate(`/dashboard/invoice?id=${student.id}&fee=${index}`)
                      }>
                        Invoice
                      </button>
                    </td>
                    <td>
                      {fee.invoiceCreated ? "GST Bill Generated" : (
                        <button
                          onClick={() => handleCreateInvoice(fee, index)}
                          className="text-green-400 hover:underline"
                        >
                          Create GST Invoice
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}




      </div>

    </div>
  );
}

/* ---------------- COMPONENTS ---------------- */
function Section({ title, children }) {
  return (
    <div className="bg-white/5 p-5 rounded-xl border border-white/10">
      <h2 className="text-orange-400 font-semibold mb-4">{title}</h2>
      {children}
    </div>
  );
}

function Input({ type = "text", ...props }) {
  return (
    <input
      type={type}
      {...props}
      className="w-full p-3 rounded bg-black/40 border border-white/20 focus:ring-2 focus:ring-orange-500"
    />
  );
}

function Select({ options = [], ...props }) {
  return (
    <select
      {...props}
      className="w-full p-3 rounded bg-black/40 border border-white/20"
    >
      <option value="">Select</option>
      {options.map((o, i) => (
        <option key={i} value={o}>{o}</option>
      ))}
    </select>
  );
}